import { render, staticRenderFns } from "./BincardIndexPeps.vue?vue&type=template&id=1ee593aa&scoped=true&"
import script from "./BincardIndexPeps.vue?vue&type=script&lang=ts&"
export * from "./BincardIndexPeps.vue?vue&type=script&lang=ts&"
import style0 from "./BincardIndexPeps.vue?vue&type=style&index=0&id=1ee593aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee593aa",
  null
  
)

export default component.exports